import clsx from 'clsx'
import { Icon } from '~/elements/Icons/Icon'
import { generateFilterString } from '../lib/generateFilterString'
import { ColorIcon, Icons as ColorIcons } from '~/elements/Icons/ColorIcon'
import { FormIcon, Icons as FormIcons } from '~/elements/Icons/FormIcon'

type Props = {
  filter: string
  label: string
  value: string
  attributeCode: string
  icon: string
  setFilter: (s: string) => void
}

export const FilterCheckbox = ({ filter, value, label, attributeCode, setFilter, icon }: Props) => {
  const handleChange = () =>
    setFilter(generateFilterString({ filterString: filter || '', value, attributeCode }))
  const checked = filter?.includes(value)
  const isColorFilter = attributeCode === 'benuta_color_filter'
  const isShapeFilter = attributeCode === 'benuta_form_new'

  return (
    <div className="py-3">
      <label
        htmlFor={`${attributeCode}_${value}`}
        className={clsx(
          'flex cursor-pointer items-center gap-x-2',
          checked && 'text-red font-bold',
          isShapeFilter && 'flex flex-col',
        )}
      >
        <div
          className={clsx(
            ' flex items-center justify-center rounded-full',
            isColorFilter
              ? checked
                ? 'h-[14px] w-[14px] border border-primary-black lg:h-6 lg:w-6'
                : 'h-[14px] w-[14px] lg:h-6 lg:w-6 '
              : isShapeFilter
              ? checked
                ? ' border-primary-black'
                : ' border-grey-border'
              : checked
              ? 'h-[14px] w-[14px] bg-primary-black lg:h-6 lg:w-6'
              : 'h-[14px] w-[14px] border border-[#A2A3A1] lg:h-6 lg:w-6',
            isShapeFilter &&
              'mx-2 mb-2 h-16 w-full !rounded-none border border-grey-border duration-200 hover:border-primary-black',
          )}
        >
          {isShapeFilter ? (
            <FormIcon
              name={icon as FormIcons}
              setHeight={checked ? 18 : 24}
              setWidth={checked ? 18 : 24}
            />
          ) : isColorFilter ? (
            <ColorIcon
              name={icon as ColorIcons}
              setHeight={checked ? 18 : 24}
              setWidth={checked ? 18 : 24}
            />
          ) : checked ? (
            <Icon name="checkmark" setHeight={19} setWidth={19} style={{ color: 'white' }} />
          ) : null}
        </div>
        <input
          type="checkbox"
          className="sr-only mr-2"
          name={`${attributeCode}_${value}`}
          id={`${attributeCode}_${value}`}
          onChange={handleChange}
          checked={checked}
        />
        <p className={clsx('text-center', checked && 'font-medium')}>{label}</p>
      </label>
    </div>
  )
}
